/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import MixedModeCreationView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/mixed-mode-creation';
import AdgroupCreateAdvancedView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/index';
import { withDelayedStyles } from '@bingads-webui-campaign-react/common-utils';
import { getAdgroupCreationStyle } from '../styles/adgroup-creation-search-styles';
import { InjectWrapperWithHoC, getDelayedCreationStyles } from '../helper';

function AdGroupCreationSearch(props) {
  const {
    perfMarker, permissions, campaignContext, isOpenCreatePanel,
  } = props;
  const { IsDSAMixedModeCampaignEnabled } = permissions;
  const { currentCampaign } = campaignContext;
  const isExperiment = _.result(currentCampaign, 'ExperimentId') > 0;
  const isMixed = currentCampaign.CampaignType === 'Default' && IsDSAMixedModeCampaignEnabled && !isExperiment;
  const InjectedView = isMixed ? MixedModeCreationView : AdgroupCreateAdvancedView;
  const AdGroupCreationSearchPerfMarker = perfMarker.createChild('AdGroupCreationSearch');
  AdGroupCreationSearchPerfMarker.willInit();

  return (<InjectWrapperWithHoC
    {...props}
    InjectViewFactory={() => Promise.resolve(InjectedView)}
    InjectViewOption={{
      perfMarker: AdGroupCreationSearchPerfMarker,
      usePanel: true,
      isForVNext: true,
      isOpenCreatePanel,
      serverContext: props.serverContext,
    }}
    styleScopeName="CampaignCreationSearch"
  />);
}

AdGroupCreationSearch.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  permissions: PropTypes.shape({
    IsDSAMixedModeCampaignEnabled: PropTypes.bool.isRequired,
  }).isRequired,
  campaignContext: PropTypes.objectOf(PropTypes.any).isRequired,
  isOpenCreatePanel: PropTypes.bool, // isOpenCreatePanel: see if the page is opened from the link in delivery status column
};

AdGroupCreationSearch.defaultProps = {
  isOpenCreatePanel: false,
};

export const StyledAdGroupCreationSearch =
  withDelayedStyles(AdGroupCreationSearch, getAdgroupCreationStyle, getDelayedCreationStyles, 'ad_group_creation_view_loaded');

